module.exports = __webpack_public_path__ + "img/btn-ggsw.104b7c43.webp";